var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['status-tag'],style:({background:_vm.backgroundColor,color:_vm.color})},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }